@if (isMultichoice || isPinggo) {
	<flx-heading size="'medium" align="center" weight="extra-light" type="creation">
		{{ isMultichoice ? 'Confirm Customer Details' : 'This is PingGo customer details.' }}
	</flx-heading>
	<div class="customer-details-container">
		<form [formGroup]="bf.bigForm" *ngIf="bf.bigForm.get('client_details')">
			@if (!isMultichoice) {
			<flx-flex-container direction="row" justifyContent="right" maxWidth="44vw">
				<flx-tabs [tabs]="tabs" [currentStep$]="currentTab$" [externalPages]="true" [hideBackground]="true" (outputEventStream)="handleTab($event)"> </flx-tabs>
			</flx-flex-container>
			}
			<flx-flex-container direction="row" justifyContent="center" maxWidth="50vw">
				<!-- customer details -->
				@if (showCustomerDetails) {
				<flx-panel density="cozy" formGroupName="client_details" margin="8">
					@if (showClarityCustomerNumber) {
					<flx-label>Clarity Customer Number</flx-label>
					<flx-input-text formControlName="clarity_customer_number" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display [control]="bf.bigForm.controls['client_details']['controls']?.clarity_customer_number"> </flx-reactive-form-error-display>
					}

					<flx-label>{{ 'first_name' | fsToHuman }}</flx-label>
					<flx-input-text formControlName="first_name" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display [control]="bf.bigForm.controls['client_details']['controls']?.first_name"></flx-reactive-form-error-display>

					<flx-label>{{ 'surname' | fsToHuman }}</flx-label>
					<flx-input-text formControlName="surname" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display [control]="bf.bigForm.controls['client_details']['controls']?.surname"> </flx-reactive-form-error-display>
					
					<flx-label>Customer Reference</flx-label>
					<flx-input-text formControlName="customer_reference" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display [control]="bf.bigForm.controls['client_details']['controls']?.customer_reference"> </flx-reactive-form-error-display>
					
					<flx-label>Sales Order Number</flx-label>
					<flx-input-text formControlName="sales_order_number" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display [control]="bf.bigForm.controls['client_details']['controls']?.sales_order_number"> </flx-reactive-form-error-display>
				</flx-panel>
				}
				<!-- contact details -->
				@if (showContactDetails) {
				<flx-panel density="cozy" formGroupName="contact_details" margin="8">
					<flx-label>Contact Number</flx-label>
					<flx-input-text formControlName="contact_number" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display [control]="bf.bigForm.controls['contact_details']['controls']?.contact_number"> </flx-reactive-form-error-display>

					<flx-label>{{ isMultichoice ? 'Alternative Contact Number' : 'Cell Number' }}</flx-label>
					<flx-input-text formControlName="cell_number" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display [control]="bf.bigForm.controls['contact_details']['controls']?.cell_number"></flx-reactive-form-error-display>

					<flx-label>Email Address</flx-label>
					<flx-input-text formControlName="email" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display [control]="bf.bigForm.controls['contact_details']['controls']?.email"> </flx-reactive-form-error-display>

					@if (!isMultichoice) {
					<div>
						<flx-label>{{ 'preferred_com_method' | fsToHuman }}</flx-label>
						<flx-dropdown
							[itemsOption]="commsOptions"
							[displayOptions]="{ displayKey: 'display', valueKey: 'value' }"
							formControlName="preferred_com_method"
							placeHolder="Select method"
							[searchEnabled]="false"
						>
						</flx-dropdown>
					</div>
					}
				</flx-panel>
				}
				<!-- address details -->
				<flx-panel density="cozy" formGroupName="insured_address" margin="8">
					@if ((currentTab$ | async) === 'house_estate' && !isMultichoice) {
						<flx-label>{{ 'estate_name' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="complex" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.complex"> </flx-reactive-form-error-display>
	
						<flx-label>{{ 'street_address' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="street_address" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.street_address"> </flx-reactive-form-error-display>
	
						<flx-label>{{ 'suburb' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="suburb" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.suburb"> </flx-reactive-form-error-display>
	
						<flx-label>{{ 'city' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="city" [noEndingSpace]="true" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.city"> </flx-reactive-form-error-display>
	
						<flx-label>{{ 'postal_code' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="postal_code" [noEndingSpace]="true" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.postal_code"> </flx-reactive-form-error-display>
					}
	
					@if ((currentTab$ | async) === 'flat_office' && !isMultichoice) {
						<flx-label>Flat/Office Name</flx-label>
						<flx-input-text formControlName="complex" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.complex"> </flx-reactive-form-error-display>
	
						<flx-label>{{ 'unit_number' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="complex_unit_number" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.complex_unit_number"> </flx-reactive-form-error-display>
	
						<flx-label>{{ 'block' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="complex_block" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.complex_block"> </flx-reactive-form-error-display>
	
						<flx-label>{{ 'street_address' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="street_address" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.street_address"> </flx-reactive-form-error-display>
	
						<flx-label>{{ 'suburb' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="suburb" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.suburb"> </flx-reactive-form-error-display>
	
						<flx-label>{{ 'city' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="city" [noEndingSpace]="true" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.city"> </flx-reactive-form-error-display>
	
						<flx-label>{{ 'postal_code' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="postal_code" [noEndingSpace]="true" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.postal_code"> </flx-reactive-form-error-display>
					}
	
					@if (isMultichoice) {
						<flx-label>{{ 'complex' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="complex" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.complex"> </flx-reactive-form-error-display>
						@if (bf.bigForm.controls['insured_address']['controls']?.complex?.value && bf.bigForm.controls['insured_address']['controls']?.complex_unit_number) {
							<flx-label>{{ 'complex_unit_number' | fsToHuman }}</flx-label>
							<flx-input-text formControlName="complex_unit_number" type="text" size="normal"></flx-input-text>
							<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.complex_unit_number"> </flx-reactive-form-error-display>
						}
						<flx-label>{{ 'street_address' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="street_address" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.street_address"> </flx-reactive-form-error-display>
						<flx-label>{{ 'suburb' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="suburb" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.suburb"> </flx-reactive-form-error-display>
						<flx-label>{{ 'city' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="city" [noEndingSpace]="true" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.city"> </flx-reactive-form-error-display>
						<flx-label>{{ 'postal_code' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="postal_code" [noEndingSpace]="true" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.postal_code"> </flx-reactive-form-error-display>
					}
	
					<flx-label>{{ 'province' | fsToHuman }}</flx-label>
					<flx-dropdown
						(itemsSelected)="setArea($event)"
						[itemsOption]="provinceList"
						[displayOptions]="{ displayKey: 'display', valueKey: 'value' }"
						formControlName="province"
						placeHolder="Select Province"
						[searchEnabled]="false"
					>
					</flx-dropdown>
					<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.province"> </flx-reactive-form-error-display>
					<!-- <ng-container
						*ngIf="bf.bigForm.controls['insured_address']['controls']?.complex?.value && bf.bigForm.controls['insured_address']['controls']?.complex_unit_number">
						<flx-label>{{ 'province' | fsToHuman }}</flx-label>
						<flx-input-text formControlName="complex_unit_number" type="text" size="normal"></flx-input-text>
						<flx-reactive-form-error-display
							[control]="bf.bigForm.controls['insured_address']['controls']?.complex_unit_number">
						</flx-reactive-form-error-display>
					</ng-container>-->
				</flx-panel>
				<!-- <flx-panel *ngIf="showAddressDetails" density="cozy" formGroupName="insured_address" margin="8">
					<flx-label *ngIf="showComplex">Complex</flx-label>
					<flx-input-text *ngIf="showComplex" formControlName="complex" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display *ngIf="showComplex" [control]="bf.bigForm?.controls?.['insured_address']?.['controls']?.complex"> </flx-reactive-form-error-display>

					<flx-label>Street Address</flx-label>
					<flx-input-text formControlName="street_address" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display [control]="bf.bigForm?.controls?.['insured_address']?.['controls']?.street_address"></flx-reactive-form-error-display>

					<flx-label>Suburb</flx-label>
					<flx-input-text formControlName="suburb" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display [control]="bf.bigForm?.controls?.['insured_address']?.['controls']?.suburb"> </flx-reactive-form-error-display>

					<flx-label>City</flx-label>
					<flx-input-text formControlName="city" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display [control]="bf.bigForm?.controls?.['insured_address']?.['controls']?.city"> </flx-reactive-form-error-display>
					<flx-label>Postal Code</flx-label>
					<flx-input-text formControlName="postal_code" type="text" size="normal"></flx-input-text>
					<flx-reactive-form-error-display [control]="bf.bigForm?.controls?.['insured_address']?.['controls']?.postal_code"> </flx-reactive-form-error-display>
					<flx-label>{{ 'province' | fsToHuman }}</flx-label>
					<flx-dropdown
						(itemsSelected)="setArea($event)"
						[itemsOption]="provinceList"
						[displayOptions]="{ displayKey: 'display', valueKey: 'value' }"
						formControlName="province"
						placeHolder="Select Province"
						[searchEnabled]="false"
					>
					</flx-dropdown>
					<flx-reactive-form-error-display [control]="bf.bigForm.controls['insured_address']['controls']?.province"> </flx-reactive-form-error-display>
				</flx-panel> -->
			</flx-flex-container>
		</form>
	</div>
}
